"use client";

import { useId } from "react";
import { Checkbox } from "@/components/ui/checkbox";

export default function DemoCheckbox({
  checked,
  label,
  onCheckedChange,
}: {
  checked: boolean;
  label: string;
  onCheckedChange: (checked: boolean) => void;
}) {
  const id = useId();

  return (
    <div className="flex items-center gap-2">
      <Checkbox
        checked={checked}
        id={id}
        onCheckedChange={(next) => onCheckedChange(next === true)}
      />
      <label
        className="cursor-pointer select-none font-medium text-sm"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}
